/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { PureComponent } from 'react';
import Media from 'react-media';
import {
    bool, object, string, shape, array, arrayOf, number, func,
} from 'prop-types';
import MobileFoodAddToCart from './Mobile/MobileFoodAddToCart';
import DesktopFoodAddToCart from './Desktop/DesktopFoodAddToCart';

export class GraphqlFoodAddToCart extends PureComponent {
    render() {
        const {
            isAddToCartEnabled,
            selectedItemId,
            brandId,
            partNumber,
            categoryId,
            categoryPath,
            categoryName,
            subscription,
            subscriptionDetails,
            productType,
            totalProductSelected,
            maxComponents,
            cyoSelectedComponents,
            fullWidth,
            disableAddToCart,
            personalizedData,
            isPersonalizable,
            product,
            presentation_family,
            addons,
            closeAddonModal,
            handleMiniCartModalClick,
            quantity,
            isBandItemSelected,
            handleMobileAgeVerification,
            isMobile,
            hasWine,
            isPassportBundleProduct,
            setAddToCartClicked,
            selectedState,
        } = this.props;
        return (
            <Media queries={{
                mobile: '(min-width: 320px) and (max-width: 767px)',
                desktop: '(min-width: 768px)',
            }}
            >
                {(matches) => (
                    matches.mobile
                        ? (
                            <MobileFoodAddToCart
                                isAddToCartEnabled={isAddToCartEnabled}
                                selectedItemId={selectedItemId}
                                brandId={brandId}
                                partNumber={partNumber}
                                categoryId={categoryId}
                                categoryPath={categoryPath}
                                categoryName={categoryName}
                                subscription={subscription}
                                subscriptionDetails={subscriptionDetails}
                                productType={productType}
                                totalProductSelected={totalProductSelected}
                                maxComponents={maxComponents}
                                cyoSelectedComponents={cyoSelectedComponents}
                                fullWidth={fullWidth}
                                disableAddToCart={disableAddToCart}
                                personalizedData={personalizedData}
                                isPersonalizable={isPersonalizable}
                                product={product}
                                quantity={quantity}
                                presentation_family={presentation_family}
                                isBandItemSelected={isBandItemSelected}
                                handleMobileAgeVerification={handleMobileAgeVerification}
                                isMobile
                                hasWine={hasWine}
                                addons={addons}
                                isPassportBundleProduct={isPassportBundleProduct || {}}
                                setAddToCartClicked={setAddToCartClicked}
                                selectedState={selectedState}
                            />
                        )
                        : (
                            <DesktopFoodAddToCart
                                isAddToCartEnabled={isAddToCartEnabled}
                                selectedItemId={selectedItemId}
                                brandId={brandId}
                                partNumber={partNumber}
                                categoryId={categoryId}
                                categoryPath={categoryPath}
                                categoryName={categoryName}
                                subscription={subscription}
                                subscriptionDetails={subscriptionDetails}
                                productType={productType}
                                totalProductSelected={totalProductSelected}
                                maxComponents={maxComponents}
                                cyoSelectedComponents={cyoSelectedComponents}
                                fullWidth={fullWidth}
                                disableAddToCart={disableAddToCart}
                                personalizedData={personalizedData}
                                isPersonalizable={isPersonalizable}
                                product={product}
                                presentation_family={presentation_family}
                                addons={addons}
                                closeAddonModal={closeAddonModal}
                                // IMP for minicart as it handels it open and close of minicart(NB: not needed in mobile)
                                handleMiniCartModalClick={handleMiniCartModalClick}
                                quantity={quantity}
                                isBandItemSelected={isBandItemSelected}
                                handleMobileAgeVerification={handleMobileAgeVerification}
                                hasWine={hasWine}
                                isMobile={isMobile}
                                isPassportBundleProduct={isPassportBundleProduct || {}}
                                setAddToCartClicked={setAddToCartClicked}
                                selectedState={selectedState}
                            />
                        ))}
            </Media>
        );
    }
}

GraphqlFoodAddToCart.propTypes = {
    categoryId: string,
    partNumber: string,
    selectedItemId: string,
    brandId: string.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
        subscriptionDurationKey: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
        subscriptionCheckbox: bool,
    }),
    productType: string,
    totalProductSelected: number,
    maxComponents: number,
    cyoSelectedComponents: array,
    fullWidth: bool,
    product: object.isRequired,
    presentation_family: string,
    disableAddToCart: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    isPersonalizable: bool,
    isAddToCartEnabled: bool,
    categoryPath: string,
    categoryName: string,
    addons: arrayOf(shape({
        brandCode: string,
        productCode: number,
        componentType: string,
        productId: string,
        quantity: number,
    })),
    isBandItemSelected: bool,
    closeAddonModal: func,
    handleMiniCartModalClick: func,
    quantity: string,
    handleMobileAgeVerification: func,
    isMobile: bool,
    hasWine: bool,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    setAddToCartClicked: func,
    selectedState: bool,
};

GraphqlFoodAddToCart.defaultProps = {
    selectedItemId: null,
    fullWidth: false,
    subscriptionDetails: {},
    subscription: {},
    productType: '',
    totalProductSelected: 0,
    maxComponents: null,
    cyoSelectedComponents: [],
    disableAddToCart: false,
    personalizedData: {},
    isPersonalizable: false,
    presentation_family: 'food',
    categoryPath: '',
    categoryName: '',
    addons: [],
    closeAddonModal: () => { },
    handleMiniCartModalClick: () => { },
    quantity: '1',
    isBandItemSelected: true,
    categoryId: '',
    partNumber: '',
    isAddToCartEnabled: false,
    handleMobileAgeVerification: () => { },
    isMobile: false,
    hasWine: false,
    isPassportBundleProduct: {},
    setAddToCartClicked: () => { },
    selectedState: false,
};

export default GraphqlFoodAddToCart;
